import {Header, Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import BusinessUserTable from '@/screens/Merchants/Users/List/MerchantUserTable';
import useMerchantList from '@/screens/Merchants/Users/List/useMerchantUserList';
import UserFilters from '@/screens/User/List/UserFilters';

const MerchantKYCList = () => {
  const {
    isLoading,
    isSearch,
    isPageReset,
    fetchAllMerchants,
    pageInfo,
    filterCount,
    currentFilters,
    filtersToApply,
    handleApplyFilters,
    clearFilters,
    handleUserAutoComplete,
    selectAppliedFilters,
    selectCurrentFilters,
    merchantList,
  } = useMerchantList();

  const renderList = () => {
    if (isLoading) {
      return <TableSkeleton />;
    }

    if (!merchantList || !merchantList.length) {
      return (
        <div className="flex items-center gap-1 justify-center mt-5">
          <p
            className="text-gray-800 dark:text-white"
            data-cy="merchant-kyc-empty-state"
          >
            No Users found.
          </p>
        </div>
      );
    }

    return <BusinessUserTable merchants={merchantList} iskyckybScreen={true} />;
  };

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={'Business KYC List'} dataCy="merchant-kyc-title" />

      <UserFilters
        filterCount={filterCount}
        currentFilters={currentFilters}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectCurrentFilters={selectCurrentFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
        handleAutoComplete={handleUserAutoComplete}
        isMerchant={true}
        dataCy="merchant-kyc"
      />

      <section className="pt-5 md:pt-5">{renderList()}</section>

      {merchantList && merchantList.length ? (
        <Pagination
          onPageChange={fetchAllMerchants as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default MerchantKYCList;
